var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.64175 2.95524C4.81041 1.94475 6.33384 1.3335 8.00004 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016C14.6667 9.42423 14.2202 10.744 13.4595 11.8272L11.3334 8.00016H13.3334C13.3334 5.05464 10.9456 2.66683 8.00004 2.66683C6.56659 2.66683 5.26522 3.23234 4.30686 4.15244L3.64175 2.95524ZM12.3583 13.0451C11.1896 14.0556 9.66624 14.6668 8.00004 14.6668C4.31814 14.6668 1.33337 11.682 1.33337 8.00016C1.33337 6.57607 1.7799 5.25627 2.54057 4.17312L4.66671 8.00016H2.66671C2.66671 10.9457 5.05452 13.3335 8.00004 13.3335C9.43351 13.3335 10.7348 12.768 11.6932 11.8479L12.3583 13.0451Z",
    fill: "#0F62FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshBlue);
export default __webpack_public_path__ + "static/media/refresh-blue.9f4271b74820b5268bd7c8ce75092c65.svg";
export { ForwardRef as ReactComponent };